import {get, set} from 'lodash'

export default {

    setFundraiserData(state, fundraiserData) {
        state.fundraiserData = {...(state.fundraiserData), ...fundraiserData}
    },

    setProjectData(state, projectData) {
        state.projectData = {...(state.projectData), ...projectData}
    },

    discardProjectData(state) {
        state.projectData = null
    },

    setStepsValidationState(state, {step, isValid}) {
        set(state.stepsValidationState, step, isValid)
    },

    touchStep(state, step) {
        state.stepsTouched.push(step)
    },

    setActiveStep(state, step) {
        state.currentStep = step
    },

    resetFeeSelection(state) {
        state.donationData.acceptFees = false
        state.donationData.coveredFees = null
    },

    discardDonationData(state) {
        state.donationData = {
            donorContactData: {
                type: 1,
                firstname: null,
                lastname: null,
                email: null,
                countryId: 'DEU',
                zipValue: null,
                cityId: null,
                cityValue: null,
                streetId: null,
                streetValue: null,
                houseNumber: null,
                isPostbox: false,
                postboxNumber: null,
                salutation: null,
                phone: null
            },
            paymentData: {
                paymentType: null,
                iban: null,
                accountHolder: null
            },
            donationAmount: "",
            acceptFees: false,
            coveredFees: null,
            noAppreciation: false,
            sendDonationReceipt: true
        }
        state.currentStep = "donationAmount"
        state.stepsValidationState = {}
        state.stepsTouched = []
        state.donationFinishedSuccessful = false
    },

    setDonationData(state, donationData) {
        state.donationData = {...(state.donationData), ...donationData}
    },

    setFormSelectChoices(state, formSelectChoices) {
        state.formSelectChoices = {...(state.formSelectChoices), ...formSelectChoices}
    },

    setDonorInformation(state, donorData) {
        state.donorData = {...(state.donorData), ...donorData}

        state.donationData.donorContactData = {...(state.donationData.donorContactData), ...donorData.person}
        state.donationData.paymentData = {...(state.donationData.paymentData), ...donorData.payment}
    },

    setDonationProp(state, {prop, value, path = null}) {
        if (path === null) {
            set(state.donationData, prop, value)
        } else {
            set(get(state.donationData, path), prop, value)
        }
    },

    setProjectIsLoaded(state, isLoaded) {
        state.projectIsLoaded = isLoaded
    },

    setDonationFinishedSuccessful(state, finished) {
        state.donationFinishedSuccessful = finished
    }
}
